module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('draggable', {
    staticClass: "draggable-container",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": {
        animation: 350,
        group: 'elements',
        handle: '.draggable-handle'
      }
    },
    on: {
      "end": _vm.afterDrag
    }
  }, [(!_vm.items || _vm.items.length < 1) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_c('v-icon', {
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v("mdi-comment-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "grey--text text--lighten-1 pl-2"
  }, [_vm._v("No Data")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item._id,
      staticClass: "draggable-item",
      class: {
        selected: item._selected
      },
      staticStyle: {
        "display": "inline-block"
      },
      style: (_vm.itemStyle),
      attrs: {
        "title": item.order,
        "data-order": item.order,
        "data-id": item._id
      },
      on: {
        "click": [function($event) {
          $event.stopPropagation();
        }, function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.unselectAll()
        }, function($event) {
          if (!$event.metaKey) { return null; }
          return _vm.selectMulti(item)
        }, function($event) {
          if (!$event.ctrlKey) { return null; }
          return _vm.selectMulti(item)
        }, function($event) {
          if (!$event.shiftKey) { return null; }
          return _vm.selectRange(item)
        }]
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "99%",
        "max-width": "99%"
      }
    }, [_vm._t("default", [_c('ObjectViewer', {
      attrs: {
        "item": item
      }
    })], {
      "item": item
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "pt-1",
      staticStyle: {
        "margin-left": "-3px",
        "margin-right": "-3px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "draggable-handle clickable",
            staticStyle: {
              "margin-top": "-1px"
            }
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_vm._t("menu", null, {
      "item": item,
      "selectedItems": _vm.selectedItems
    }), _vm._v(" "), _c('v-list-item', [_c('v-list-item-title', [_vm._v("Sortable List Menu")])], 1)], 2)], 1)], 1)])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06dfce55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/SortableList.vue
// module id = 2437
// module chunks = 1